export const formatImageSource = (
  source: string,
  width: number = 0,
  isSquare: boolean = false,
) => {
  if (!source) {
    return {
      src: '',
      srcSet: '',
    }
  }

  const sourceWithoutParams = source.split('?')[0]

  const squareOption = isSquare ? 'crop=1:1&' : ''

  if (width === 0) {
    return {
      src: sourceWithoutParams,
      srcSet: sourceWithoutParams,
    }
  }

  // `width` is the intended CSS display width. Emit 1x/2x/3x density candidates
  // so retina phones (iPhones are DPR 2–3) get a crisp image while lower-DPR
  // devices download only what they need.
  const candidate = (w: number) =>
    `${sourceWithoutParams}?${squareOption}quality=80&width=${w}&format=webp`

  return {
    src: candidate(width),
    srcSet: `${candidate(width)} 1x, ${candidate(width * 2)} 2x, ${candidate(
      width * 3,
    )} 3x`,
  }
}
